import { all } from 'redux-saga/effects'

import order from './order'
// import footer from './footer'

function * rootSaga () {
  yield all([
    order(),
    // footer(),
  ])
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/saga/rootSaga.js